var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66.015,
    height: 66.015,
    viewBox: "0 0 17.466 17.466",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.677 17.03L.437 9.79a1.493 1.493 0 010-2.113l7.24-7.24a1.493 1.493 0 012.112 0l7.24 7.24a1.494 1.494 0 010 2.112l-7.24 7.24a1.494 1.494 0 01-2.112 0",
    fill: "#f0f328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 10.36h.004zm-5.786-.204l2.717 1.555 2.717-1.555V7.002L8.598 5.447 5.88 7.002zm2.717 2.314a.356.356 0 01-.175-.046l-3.07-1.757a.353.353 0 01-.178-.307V6.797c0-.126.068-.243.178-.306l3.07-1.757a.353.353 0 01.35 0l3.07 1.757c.11.063.177.18.177.306v3.563a.353.353 0 01-.177.307l-3.07 1.757a.355.355 0 01-.175.046",
    fill: "#f5941d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.398 6.718l-.8-.458L6.586 7.41v2.336l1.437.822z",
    fill: "#fdfeff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.782 11.244L5.88 10.156V7.002l2.717-1.555 1.041.596.241-.675-1.107-.634a.353.353 0 00-.35 0l-3.07 1.757a.354.354 0 00-.178.307v3.562c0 .127.068.244.178.307l2.187 1.252z",
    fill: "#fdfeff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06 1.832l6.185 6.052.638-.356L9.29.936a.781.781 0 00-.557-.23.783.783 0 00-.557.23L.79 8.323a.581.581 0 000 .821l.587.588z",
    fill: "#fdfeff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.53 8.176l-.346-.346-3.458 1.741v.79c0 .378-.204.73-.532.918l-3.07 1.757a1.06 1.06 0 01-1.052 0l-3.07-1.757c-.037-.022-.066-.052-.1-.077H2.848l5.328 5.328c.149.15.347.231.557.231.21 0 .409-.082.557-.23l7.24-7.24a.79.79 0 000-1.115",
    fill: "#f5941d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGold);
export default __webpack_public_path__ + "static/media/icon-gold.b609b22cad92e176ec35ec2aa232b106.svg";
export { ForwardRef as ReactComponent };